export default "__VITE_ASSET__EVo2KcMV__"